import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const ContractIllustration = ({ width = 160, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <path
                  fill="#B2B2B2"
                  d="M0 14.409L17.341 132.8 114.296 118.389 96.955 0z"
                  transform="translate(-304 -89) translate(0 69) translate(304 20) translate(19.2 13.6)"
                />
                <path
                  fill="#B2B2B2"
                  d="M8.146 126.233L106.15 126.233 106.15 6.564 8.146 6.564z"
                  transform="translate(-304 -89) translate(0 69) translate(304 20) translate(19.2 13.6)"
                />
                <path
                  fill="#FFF"
                  d="M9.631 124.737L104.665 124.737 104.665 8.06 9.631 8.06z"
                  transform="translate(-304 -89) translate(0 69) translate(304 20) translate(19.2 13.6)"
                />
                <path
                  fill="#878787"
                  d="M27.45 102.299L71.872 102.299 71.872 93.324 27.45 93.324zM27.45 81.356L86.846 81.356 86.846 72.381 27.45 72.381zM27.45 60.414L86.846 60.414 86.846 51.438 27.45 51.438z"
                  transform="translate(-304 -89) translate(0 69) translate(304 20) translate(19.2 13.6)"
                />
                <path
                  fill="#004C90"
                  d="M27.45 33.488L63.088 33.488 63.088 24.512 27.45 24.512z"
                  transform="translate(-304 -89) translate(0 69) translate(304 20) translate(19.2 13.6)"
                />
                <path
                  fill="#1D1D1B"
                  d="M57.148 126.233L106.15 126.233 106.15 6.561 57.148 6.561z"
                  opacity=".1"
                  transform="translate(-304 -89) translate(0 69) translate(304 20) translate(19.2 13.6)"
                />
                <path
                  fill="#00396C"
                  d="M111.235 77.366c2.19-2.462 5.946-2.672 8.387-.464 2.317 2.089 2.622 5.592.79 8.048l-.33.401-29.255 32.91c-2.248 2.528-6.1 2.65-8.5.36l-.35-.36-15.289-17.197c-2.186-2.462-1.98-6.244.46-8.449 2.32-2.09 5.81-2.013 8.03.096l.357.368 10.867 12.219 24.833-27.932z"
                  transform="translate(-304 -89) translate(0 69) translate(304 20) translate(19.2 13.6)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </DefaultIconWrapper>
);
